// @flow

import type { GlobalState } from '../types';

export const getAssortmentStore = (state: GlobalState) => state.assortment;

export const getAssortment = (state: GlobalState) => (
  getAssortmentStore(state).assortment
);

export const getFilteredAssortment = (state: GlobalState) => (
  getAssortmentStore(state).filteredAssortment
);

export const getResultCount = (state: GlobalState) => (
  getFilteredAssortment(state).length
);
